// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Wizard Overlay */
.wizard-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
  padding: 16px;
  backdrop-filter: blur(4px);
}

/* Wizard Container */
.wizard-container {
  background: #1a1a1a;
  border-radius: 12px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.5);
  max-width: 1000px;
  width: 100%;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  border: 1px solid #374151;
  overflow: hidden;
}

/* Header */
.wizard-header {
  background: #1a1a1a;
  border-bottom: 1px solid #374151;
  padding: 20px 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-shrink: 0;
}

.wizard-title {
  margin: 0;
  font-size: 20px;
  font-weight: 700;
  color: #ffffff;
}

.wizard-subtitle {
  margin: 4px 0 0 0;
  font-size: 14px;
  color: #9ca3af;
}

.wizard-close-btn {
  background: transparent;
  border: none;
  color: #9ca3af;
  cursor: pointer;
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: color 0.2s;
}

.wizard-close-btn:hover:not(:disabled) {
  color: #ffffff;
}

.wizard-close-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* Progress Steps */
.wizard-progress {
  background: #1a1a1a;
  border-bottom: 1px solid #374151;
  padding: 20px 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 24px;
  flex-shrink: 0;
}

.wizard-step-indicator {
  display: flex;
  align-items: center;
  gap: 8px;
}

.wizard-step-number {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 600;
  background: #374151;
  color: #9ca3af;
  transition: all 0.3s;
}

.wizard-step-number.active {
  background: #A61B34;
  color: #ffffff;
}

.wizard-step-number.completed {
  background: #22c55e;
  color: #ffffff;
}

.wizard-step-label {
  font-size: 14px;
  color: #9ca3af;
  font-weight: 400;
  transition: all 0.3s;
}

.wizard-step-label.active {
  color: #ffffff;
  font-weight: 600;
}

.wizard-step-divider {
  width: 48px;
  height: 1px;
  background: #374151;
}

/* Content */
.wizard-content {
  flex: 1 1;
  overflow-y: auto;
  padding: 24px;
  background: #0a0a0a;
}

.wizard-step-content {
  max-width: 900px;
  margin: 0 auto;
}

.wizard-step-header {
  margin-bottom: 16px;
}

.wizard-step-title {
  font-size: 18px;
  font-weight: 600;
  color: #ffffff;
  margin: 0 0 4px 0;
}

.wizard-step-description {
  font-size: 13px;
  color: #9ca3af;
  margin: 0;
}

/* Error Message */
.wizard-error {
  display: flex;
  align-items: center;
  gap: 8px;
  background: rgba(239, 68, 68, 0.1);
  border: 1px solid rgba(239, 68, 68, 0.3);
  color: #f87171;
  padding: 12px 16px;
  border-radius: 8px;
  margin-bottom: 20px;
  font-size: 14px;
  animation: slideDown 0.3s ease-out;
}

@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Field Error */
.wizard-field-error {
  display: flex;
  align-items: center;
  gap: 4px;
  color: #f87171;
  font-size: 12px;
  margin-top: 4px;
  animation: fadeIn 0.2s ease-out;
}

.wizard-field-error::before {
  content: '⚠';
  font-size: 14px;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.wizard-input.input-error {
  border-color: #ef4444;
  background: rgba(239, 68, 68, 0.05);
}

.wizard-input.input-error:focus {
  border-color: #ef4444;
  box-shadow: 0 0 0 3px rgba(239, 68, 68, 0.1);
}

/* Success state for valid inputs */
.wizard-input.input-success {
  border-color: #22c55e;
}

.wizard-input.input-success:focus {
  border-color: #22c55e;
  box-shadow: 0 0 0 3px rgba(34, 197, 94, 0.1);
}

/* Site Type Selection */
.site-type-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
  margin-bottom: 24px;
}

.site-type-card {
  position: relative;
  padding: 32px 24px;
  border-radius: 12px;
  border: 2px solid #374151;
  background: #0a0a0a;
  cursor: pointer;
  transition: all 0.2s;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
}

.site-type-card:hover {
  border-color: #4b5563;
  transform: translateY(-2px);
}

.site-type-card.selected {
  border-color: #A61B34;
  background: rgba(166, 27, 52, 0.1);
}

.site-type-icon {
  width: 64px;
  height: 64px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #374151;
  color: #ffffff;
  transition: all 0.2s;
}

.site-type-icon.selected {
  background: #A61B34;
}

.site-type-title {
  font-size: 18px;
  font-weight: 700;
  color: #ffffff;
  margin: 0;
}

.site-type-description {
  font-size: 12px;
  color: #9ca3af;
  text-align: center;
}

.site-type-check {
  color: #A61B34;
  position: absolute;
  top: 12px;
  right: 12px;
}

/* Info Box */
.wizard-info-box {
  background: #0a0a0a;
  border: 1px solid #374151;
  border-radius: 8px;
  padding: 16px;
}

.wizard-info-title {
  font-size: 14px;
  font-weight: 600;
  color: #ffffff;
  margin: 0 0 8px 0;
}

.wizard-info-text {
  font-size: 14px;
  color: #9ca3af;
  margin: 0;
  line-height: 1.5;
}

/* Form */
.wizard-form-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
}

.wizard-form-field {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.wizard-form-field-full {
  grid-column: 1 / -1;
}

.wizard-form-label {
  font-size: 14px;
  font-weight: 500;
  color: #e5e7eb;
  display: flex;
  align-items: center;
  gap: 4px;
}

.wizard-form-label.required::after {
  content: '*';
  color: #f87171;
  margin-left: 2px;
}

.wizard-input-with-button {
  position: relative;
  display: flex;
  gap: 8px;
  align-items: center;
}

.wizard-input-with-button .wizard-input {
  flex: 1 1;
}

.wizard-location-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px;
  background: #A61B34;
  border: 1px solid #A61B34;
  border-radius: 8px;
  color: #ffffff;
  cursor: pointer;
  transition: all 0.2s;
  flex-shrink: 0;
}

.wizard-location-btn:hover {
  background: #8B1528;
  border-color: #8B1528;
}

.wizard-location-btn:active {
  transform: scale(0.95);
}


.wizard-input {
  padding: 10px 12px;
  background: #0a0a0a;
  border: 1px solid #374151;
  border-radius: 8px;
  color: #ffffff;
  font-size: 14px;
  outline: none;
  transition: all 0.2s;
}

.wizard-input:focus {
  border-color: #A61B34;
  box-shadow: 0 0 0 3px rgba(166, 27, 52, 0.1);
}

.wizard-input:disabled,
.wizard-input:read-only {
  background: #0a0a0a;
  cursor: not-allowed;
  opacity: 0.7;
}

.wizard-input::placeholder {
  color: #6b7280;
}

.wizard-checkboxes {
  display: flex;
  gap: 24px;
  align-items: center;
}

.wizard-checkbox {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  font-size: 14px;
  color: #e5e7eb;
}

.wizard-checkbox input[type="checkbox"] {
  width: 18px;
  height: 18px;
  cursor: pointer;
  accent-color: #A61B34;
}

/* Devices */
.wizard-devices-container {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.wizard-device-section {
  background: #1a1a1a;
  border: 1px solid #374151;
  border-radius: 12px;
  overflow: hidden;
}

.wizard-device-header {
  padding: 16px 20px;
  background: rgba(166, 27, 52, 0.05);
  border-bottom: 1px solid #374151;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.wizard-device-title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 16px;
  font-weight: 600;
  color: #ffffff;
  margin: 0;
}

.wizard-device-limit,
.wizard-device-optional {
  font-size: 12px;
  font-weight: 400;
  color: #9ca3af;
}

.wizard-device-count {
  font-size: 12px;
  color: #9ca3af;
}

.wizard-device-list {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 8px;
  padding: 16px;
  max-height: 200px;
  overflow-y: auto;
  background: #0a0a0a;
}

.wizard-device-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 12px;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s;
  border: 1px solid transparent;
  background: transparent;
}

.wizard-device-item:hover {
  background: rgba(55, 65, 81, 0.3);
}

.wizard-device-item.selected {
  background: rgba(166, 27, 52, 0.2);
  border-color: #A61B34;
}

.wizard-device-item input[type="checkbox"] {
  width: 16px;
  height: 16px;
  cursor: pointer;
  accent-color: #A61B34;
  flex-shrink: 0;
}

.wizard-device-item span {
  font-size: 14px;
  color: #ffffff;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.wizard-empty-state {
  grid-column: 1 / -1;
  text-align: center;
  padding: 32px 16px;
  color: #6b7280;
  font-size: 14px;
}

/* Footer */
.wizard-footer {
  background: #1a1a1a;
  border-top: 1px solid #374151;
  padding: 20px 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-shrink: 0;
}

.wizard-btn-primary {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 24px;
  background: #A61B34;
  color: #ffffff;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
}

.wizard-btn-primary:hover:not(:disabled) {
  background: #8B1528;
}

.wizard-btn-primary:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.wizard-btn-secondary {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 24px;
  background: transparent;
  color: #9ca3af;
  border: 1px solid #374151;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
}

.wizard-btn-secondary:hover:not(:disabled) {
  background: #374151;
  color: #ffffff;
}

.wizard-btn-secondary:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* Responsive */
@media (max-width: 768px) {
  .wizard-container {
    max-width: 100%;
    max-height: 95vh;
  }

  .site-type-grid {
    grid-template-columns: 1fr;
  }

  .wizard-form-grid {
    grid-template-columns: 1fr;
  }

  .wizard-device-list {
    grid-template-columns: 1fr;
  }

  .wizard-progress {
    flex-wrap: wrap;
    gap: 12px;
  }

  .wizard-step-divider {
    display: none;
  }
}

/* Device Selector Back Bar */
.device-selector-back-bar {
  margin-bottom: 12px;
}

.device-selector-back-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  background: transparent;
  border: 1px solid #374151;
  border-radius: 6px;
  color: #9ca3af;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}

.device-selector-back-btn:hover {
  background: #1a1a1a;
  border-color: #60a5fa;
  color: #60a5fa;
}

.device-selector-actions-bar {
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
  padding-top: 20px;
  border-top: 1px solid #1f2937;
}

/* Selected Devices Summary */
.selected-devices-summary {
  background: #000000;
  border: 1px solid #1f2937;
  border-radius: 12px;
  padding: 24px;
  margin-top: 32px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.4);
}

.summary-title {
  font-size: 18px;
  font-weight: 600;
  color: #f3f4f6;
  margin: 0 0 20px 0;
  padding-bottom: 12px;
  border-bottom: 2px solid #1f2937;
}

.summary-section {
  margin-bottom: 20px;
}

.summary-section:last-child {
  margin-bottom: 0;
}

.summary-section-header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 12px;
  color: #60a5fa;
}

.summary-section-header h5 {
  font-size: 15px;
  font-weight: 600;
  color: #e5e7eb;
  margin: 0;
}

.summary-devices-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding-left: 24px;
}

.summary-device-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 14px;
  background: #0a0a0a;
  border: 1px solid #1f2937;
  border-radius: 8px;
  transition: all 0.2s;
}

.summary-device-item:hover {
  background: #111111;
  border-color: #374151;
}

.summary-device-info {
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  flex: 1 1;
  min-width: 0;
}

.summary-device-serial {
  font-size: 14px;
  font-weight: 500;
  color: #f3f4f6;
  font-family: 'Courier New', monospace;
}

.summary-device-model {
  font-size: 12px;
  color: #9ca3af;
}

.summary-device-remove {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  padding: 0;
  background: #374151;
  border: none;
  border-radius: 8px;
  color: #9ca3af;
  cursor: pointer;
  transition: all 0.2s;
}

.summary-device-remove:hover {
  background: #991B1B;
  color: #FCA5A5;
  transform: scale(1.05);
}

.summary-device-remove:active {
  transform: scale(0.95);
}

/* Scrollbar personalizado */
.wizard-device-list::-webkit-scrollbar {
  width: 8px;
}

.wizard-device-list::-webkit-scrollbar-track {
  background: #0a0a0a;
}

.wizard-device-list::-webkit-scrollbar-thumb {
  background: #374151;
  border-radius: 4px;
}

.wizard-device-list::-webkit-scrollbar-thumb:hover {
  background: #4b5563;
}

.wizard-content::-webkit-scrollbar {
  width: 10px;
}

.wizard-content::-webkit-scrollbar-track {
  background: #0a0a0a;
}

.wizard-content::-webkit-scrollbar-thumb {
  background: #374151;
  border-radius: 5px;
}

.wizard-content::-webkit-scrollbar-thumb:hover {
  background: #4b5563;
}

/* Configuración de dispositivos */
.summary-device-actions {
  display: flex;
  align-items: center;
  gap: 6px;
}

.summary-device-configure {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  padding: 0;
  background: #374151;
  border: none;
  border-radius: 8px;
  color: #9ca3af;
  cursor: pointer;
  transition: all 0.2s;
  flex-shrink: 0;
}

.summary-device-configure:hover {
  background: #4B5563;
  color: #60A5FA;
  transform: scale(1.05);
}

.summary-device-configure.configured {
  background: #374151;
  color: #4ade80;
}

.summary-device-configure.configured:hover {
  background: #4B5563;
  color: #86efac;
  transform: scale(1.05);
}

.summary-device-configured {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px 8px;
  background: rgba(34, 197, 94, 0.15);
  border: 1px solid rgba(34, 197, 94, 0.3);
  border-radius: 6px;
  color: #4ade80;
  font-size: 11px;
  font-weight: 600;
  flex-shrink: 0;
}

.summary-device-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 12px;
  background: rgba(255, 255, 255, 0.02);
  border: 1px solid rgba(255, 255, 255, 0.05);
  border-radius: 6px;
  transition: all 0.2s;
}

.summary-device-item:hover {
  background: rgba(255, 255, 255, 0.04);
  border-color: rgba(255, 255, 255, 0.1);
}

.summary-device-info {
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  flex: 1 1;
  min-width: 0;
}

.summary-device-info .summary-device-serial {
  margin-right: 4px;
}

.summary-device-info .summary-device-model {
  margin-right: 4px;
}

.summary-device-info .summary-device-configured {
  margin-left: 0;
}
`, "",{"version":3,"sources":["webpack://./src/components/CreateSiteWizard.css"],"names":[],"mappings":"AAAA,mBAAmB;AACnB;EACE,eAAe;EACf,QAAQ;EACR,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;EACb,0BAA0B;AAC5B;;AAEA,qBAAqB;AACrB;EACE,mBAAmB;EACnB,mBAAmB;EACnB,0CAA0C;EAC1C,iBAAiB;EACjB,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA,WAAW;AACX;EACE,mBAAmB;EACnB,gCAAgC;EAChC,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,mBAAmB;AACnB;EACE,mBAAmB;EACnB,gCAAgC;EAChC,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,mBAAmB;AACrB;;AAEA,YAAY;AACZ;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;AACX;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kCAAkC;EAClC,wCAAwC;EACxC,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,eAAe;EACf,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,qBAAqB;EACrB,mCAAmC;AACrC;;AAEA;EACE,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA,mCAAmC;AACnC;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,oBAAoB;EACpB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,qBAAqB;EACrB,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,SAAS;EACT,WAAW;AACb;;AAEA,aAAa;AACb;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;EACT,gBAAgB;AAClB;;AAEA,SAAS;AACT;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;AACxB;;;AAGA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;;EAEE,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,qBAAqB;AACvB;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,mCAAmC;EACnC,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;;EAEE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;EACR,aAAa;EACb,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,6BAA6B;EAC7B,uBAAuB;AACzB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,kCAAkC;EAClC,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA,WAAW;AACX;EACE,mBAAmB;EACnB,6BAA6B;EAC7B,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,eAAe;AACf;EACE;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,eAAe;IACf,SAAS;EACX;;EAEA;IACE,aAAa;EACf;AACF;;AAEA,6BAA6B;AAC7B;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA,6BAA6B;AAC7B;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,wCAAwC;AAC1C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,QAAQ;EACR,SAAO;EACP,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,qCAAqC;AACvC;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA,4BAA4B;AAC5B;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,kCAAkC;AAClC;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,mCAAmC;EACnC,wCAAwC;EACxC,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,qCAAqC;EACrC,2CAA2C;EAC3C,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,qCAAqC;EACrC,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,QAAQ;EACR,SAAO;EACP,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB","sourcesContent":["/* Wizard Overlay */\n.wizard-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 2000;\n  padding: 16px;\n  backdrop-filter: blur(4px);\n}\n\n/* Wizard Container */\n.wizard-container {\n  background: #1a1a1a;\n  border-radius: 12px;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.5);\n  max-width: 1000px;\n  width: 100%;\n  max-height: 90vh;\n  display: flex;\n  flex-direction: column;\n  border: 1px solid #374151;\n  overflow: hidden;\n}\n\n/* Header */\n.wizard-header {\n  background: #1a1a1a;\n  border-bottom: 1px solid #374151;\n  padding: 20px 24px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-shrink: 0;\n}\n\n.wizard-title {\n  margin: 0;\n  font-size: 20px;\n  font-weight: 700;\n  color: #ffffff;\n}\n\n.wizard-subtitle {\n  margin: 4px 0 0 0;\n  font-size: 14px;\n  color: #9ca3af;\n}\n\n.wizard-close-btn {\n  background: transparent;\n  border: none;\n  color: #9ca3af;\n  cursor: pointer;\n  padding: 4px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: color 0.2s;\n}\n\n.wizard-close-btn:hover:not(:disabled) {\n  color: #ffffff;\n}\n\n.wizard-close-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n/* Progress Steps */\n.wizard-progress {\n  background: #1a1a1a;\n  border-bottom: 1px solid #374151;\n  padding: 20px 24px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 24px;\n  flex-shrink: 0;\n}\n\n.wizard-step-indicator {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.wizard-step-number {\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 14px;\n  font-weight: 600;\n  background: #374151;\n  color: #9ca3af;\n  transition: all 0.3s;\n}\n\n.wizard-step-number.active {\n  background: #A61B34;\n  color: #ffffff;\n}\n\n.wizard-step-number.completed {\n  background: #22c55e;\n  color: #ffffff;\n}\n\n.wizard-step-label {\n  font-size: 14px;\n  color: #9ca3af;\n  font-weight: 400;\n  transition: all 0.3s;\n}\n\n.wizard-step-label.active {\n  color: #ffffff;\n  font-weight: 600;\n}\n\n.wizard-step-divider {\n  width: 48px;\n  height: 1px;\n  background: #374151;\n}\n\n/* Content */\n.wizard-content {\n  flex: 1;\n  overflow-y: auto;\n  padding: 24px;\n  background: #0a0a0a;\n}\n\n.wizard-step-content {\n  max-width: 900px;\n  margin: 0 auto;\n}\n\n.wizard-step-header {\n  margin-bottom: 16px;\n}\n\n.wizard-step-title {\n  font-size: 18px;\n  font-weight: 600;\n  color: #ffffff;\n  margin: 0 0 4px 0;\n}\n\n.wizard-step-description {\n  font-size: 13px;\n  color: #9ca3af;\n  margin: 0;\n}\n\n/* Error Message */\n.wizard-error {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  background: rgba(239, 68, 68, 0.1);\n  border: 1px solid rgba(239, 68, 68, 0.3);\n  color: #f87171;\n  padding: 12px 16px;\n  border-radius: 8px;\n  margin-bottom: 20px;\n  font-size: 14px;\n  animation: slideDown 0.3s ease-out;\n}\n\n@keyframes slideDown {\n  from {\n    opacity: 0;\n    transform: translateY(-10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* Field Error */\n.wizard-field-error {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  color: #f87171;\n  font-size: 12px;\n  margin-top: 4px;\n  animation: fadeIn 0.2s ease-out;\n}\n\n.wizard-field-error::before {\n  content: '⚠';\n  font-size: 14px;\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n.wizard-input.input-error {\n  border-color: #ef4444;\n  background: rgba(239, 68, 68, 0.05);\n}\n\n.wizard-input.input-error:focus {\n  border-color: #ef4444;\n  box-shadow: 0 0 0 3px rgba(239, 68, 68, 0.1);\n}\n\n/* Success state for valid inputs */\n.wizard-input.input-success {\n  border-color: #22c55e;\n}\n\n.wizard-input.input-success:focus {\n  border-color: #22c55e;\n  box-shadow: 0 0 0 3px rgba(34, 197, 94, 0.1);\n}\n\n/* Site Type Selection */\n.site-type-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 16px;\n  margin-bottom: 24px;\n}\n\n.site-type-card {\n  position: relative;\n  padding: 32px 24px;\n  border-radius: 12px;\n  border: 2px solid #374151;\n  background: #0a0a0a;\n  cursor: pointer;\n  transition: all 0.2s;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 12px;\n}\n\n.site-type-card:hover {\n  border-color: #4b5563;\n  transform: translateY(-2px);\n}\n\n.site-type-card.selected {\n  border-color: #A61B34;\n  background: rgba(166, 27, 52, 0.1);\n}\n\n.site-type-icon {\n  width: 64px;\n  height: 64px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: #374151;\n  color: #ffffff;\n  transition: all 0.2s;\n}\n\n.site-type-icon.selected {\n  background: #A61B34;\n}\n\n.site-type-title {\n  font-size: 18px;\n  font-weight: 700;\n  color: #ffffff;\n  margin: 0;\n}\n\n.site-type-description {\n  font-size: 12px;\n  color: #9ca3af;\n  text-align: center;\n}\n\n.site-type-check {\n  color: #A61B34;\n  position: absolute;\n  top: 12px;\n  right: 12px;\n}\n\n/* Info Box */\n.wizard-info-box {\n  background: #0a0a0a;\n  border: 1px solid #374151;\n  border-radius: 8px;\n  padding: 16px;\n}\n\n.wizard-info-title {\n  font-size: 14px;\n  font-weight: 600;\n  color: #ffffff;\n  margin: 0 0 8px 0;\n}\n\n.wizard-info-text {\n  font-size: 14px;\n  color: #9ca3af;\n  margin: 0;\n  line-height: 1.5;\n}\n\n/* Form */\n.wizard-form-grid {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 20px;\n}\n\n.wizard-form-field {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.wizard-form-field-full {\n  grid-column: 1 / -1;\n}\n\n.wizard-form-label {\n  font-size: 14px;\n  font-weight: 500;\n  color: #e5e7eb;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.wizard-form-label.required::after {\n  content: '*';\n  color: #f87171;\n  margin-left: 2px;\n}\n\n.wizard-input-with-button {\n  position: relative;\n  display: flex;\n  gap: 8px;\n  align-items: center;\n}\n\n.wizard-input-with-button .wizard-input {\n  flex: 1;\n}\n\n.wizard-location-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 10px;\n  background: #A61B34;\n  border: 1px solid #A61B34;\n  border-radius: 8px;\n  color: #ffffff;\n  cursor: pointer;\n  transition: all 0.2s;\n  flex-shrink: 0;\n}\n\n.wizard-location-btn:hover {\n  background: #8B1528;\n  border-color: #8B1528;\n}\n\n.wizard-location-btn:active {\n  transform: scale(0.95);\n}\n\n\n.wizard-input {\n  padding: 10px 12px;\n  background: #0a0a0a;\n  border: 1px solid #374151;\n  border-radius: 8px;\n  color: #ffffff;\n  font-size: 14px;\n  outline: none;\n  transition: all 0.2s;\n}\n\n.wizard-input:focus {\n  border-color: #A61B34;\n  box-shadow: 0 0 0 3px rgba(166, 27, 52, 0.1);\n}\n\n.wizard-input:disabled,\n.wizard-input:read-only {\n  background: #0a0a0a;\n  cursor: not-allowed;\n  opacity: 0.7;\n}\n\n.wizard-input::placeholder {\n  color: #6b7280;\n}\n\n.wizard-checkboxes {\n  display: flex;\n  gap: 24px;\n  align-items: center;\n}\n\n.wizard-checkbox {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  cursor: pointer;\n  font-size: 14px;\n  color: #e5e7eb;\n}\n\n.wizard-checkbox input[type=\"checkbox\"] {\n  width: 18px;\n  height: 18px;\n  cursor: pointer;\n  accent-color: #A61B34;\n}\n\n/* Devices */\n.wizard-devices-container {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n}\n\n.wizard-device-section {\n  background: #1a1a1a;\n  border: 1px solid #374151;\n  border-radius: 12px;\n  overflow: hidden;\n}\n\n.wizard-device-header {\n  padding: 16px 20px;\n  background: rgba(166, 27, 52, 0.05);\n  border-bottom: 1px solid #374151;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.wizard-device-title {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 16px;\n  font-weight: 600;\n  color: #ffffff;\n  margin: 0;\n}\n\n.wizard-device-limit,\n.wizard-device-optional {\n  font-size: 12px;\n  font-weight: 400;\n  color: #9ca3af;\n}\n\n.wizard-device-count {\n  font-size: 12px;\n  color: #9ca3af;\n}\n\n.wizard-device-list {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 8px;\n  padding: 16px;\n  max-height: 200px;\n  overflow-y: auto;\n  background: #0a0a0a;\n}\n\n.wizard-device-item {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 12px;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: all 0.2s;\n  border: 1px solid transparent;\n  background: transparent;\n}\n\n.wizard-device-item:hover {\n  background: rgba(55, 65, 81, 0.3);\n}\n\n.wizard-device-item.selected {\n  background: rgba(166, 27, 52, 0.2);\n  border-color: #A61B34;\n}\n\n.wizard-device-item input[type=\"checkbox\"] {\n  width: 16px;\n  height: 16px;\n  cursor: pointer;\n  accent-color: #A61B34;\n  flex-shrink: 0;\n}\n\n.wizard-device-item span {\n  font-size: 14px;\n  color: #ffffff;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.wizard-empty-state {\n  grid-column: 1 / -1;\n  text-align: center;\n  padding: 32px 16px;\n  color: #6b7280;\n  font-size: 14px;\n}\n\n/* Footer */\n.wizard-footer {\n  background: #1a1a1a;\n  border-top: 1px solid #374151;\n  padding: 20px 24px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-shrink: 0;\n}\n\n.wizard-btn-primary {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 24px;\n  background: #A61B34;\n  color: #ffffff;\n  border: none;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.wizard-btn-primary:hover:not(:disabled) {\n  background: #8B1528;\n}\n\n.wizard-btn-primary:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.wizard-btn-secondary {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 24px;\n  background: transparent;\n  color: #9ca3af;\n  border: 1px solid #374151;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.wizard-btn-secondary:hover:not(:disabled) {\n  background: #374151;\n  color: #ffffff;\n}\n\n.wizard-btn-secondary:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n  .wizard-container {\n    max-width: 100%;\n    max-height: 95vh;\n  }\n\n  .site-type-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .wizard-form-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .wizard-device-list {\n    grid-template-columns: 1fr;\n  }\n\n  .wizard-progress {\n    flex-wrap: wrap;\n    gap: 12px;\n  }\n\n  .wizard-step-divider {\n    display: none;\n  }\n}\n\n/* Device Selector Back Bar */\n.device-selector-back-bar {\n  margin-bottom: 12px;\n}\n\n.device-selector-back-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 6px 12px;\n  background: transparent;\n  border: 1px solid #374151;\n  border-radius: 6px;\n  color: #9ca3af;\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.device-selector-back-btn:hover {\n  background: #1a1a1a;\n  border-color: #60a5fa;\n  color: #60a5fa;\n}\n\n.device-selector-actions-bar {\n  display: flex;\n  justify-content: flex-end;\n  margin-top: 20px;\n  padding-top: 20px;\n  border-top: 1px solid #1f2937;\n}\n\n/* Selected Devices Summary */\n.selected-devices-summary {\n  background: #000000;\n  border: 1px solid #1f2937;\n  border-radius: 12px;\n  padding: 24px;\n  margin-top: 32px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.4);\n}\n\n.summary-title {\n  font-size: 18px;\n  font-weight: 600;\n  color: #f3f4f6;\n  margin: 0 0 20px 0;\n  padding-bottom: 12px;\n  border-bottom: 2px solid #1f2937;\n}\n\n.summary-section {\n  margin-bottom: 20px;\n}\n\n.summary-section:last-child {\n  margin-bottom: 0;\n}\n\n.summary-section-header {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 12px;\n  color: #60a5fa;\n}\n\n.summary-section-header h5 {\n  font-size: 15px;\n  font-weight: 600;\n  color: #e5e7eb;\n  margin: 0;\n}\n\n.summary-devices-list {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  padding-left: 24px;\n}\n\n.summary-device-item {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 10px 14px;\n  background: #0a0a0a;\n  border: 1px solid #1f2937;\n  border-radius: 8px;\n  transition: all 0.2s;\n}\n\n.summary-device-item:hover {\n  background: #111111;\n  border-color: #374151;\n}\n\n.summary-device-info {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 8px;\n  flex: 1;\n  min-width: 0;\n}\n\n.summary-device-serial {\n  font-size: 14px;\n  font-weight: 500;\n  color: #f3f4f6;\n  font-family: 'Courier New', monospace;\n}\n\n.summary-device-model {\n  font-size: 12px;\n  color: #9ca3af;\n}\n\n.summary-device-remove {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  padding: 0;\n  background: #374151;\n  border: none;\n  border-radius: 8px;\n  color: #9ca3af;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.summary-device-remove:hover {\n  background: #991B1B;\n  color: #FCA5A5;\n  transform: scale(1.05);\n}\n\n.summary-device-remove:active {\n  transform: scale(0.95);\n}\n\n/* Scrollbar personalizado */\n.wizard-device-list::-webkit-scrollbar {\n  width: 8px;\n}\n\n.wizard-device-list::-webkit-scrollbar-track {\n  background: #0a0a0a;\n}\n\n.wizard-device-list::-webkit-scrollbar-thumb {\n  background: #374151;\n  border-radius: 4px;\n}\n\n.wizard-device-list::-webkit-scrollbar-thumb:hover {\n  background: #4b5563;\n}\n\n.wizard-content::-webkit-scrollbar {\n  width: 10px;\n}\n\n.wizard-content::-webkit-scrollbar-track {\n  background: #0a0a0a;\n}\n\n.wizard-content::-webkit-scrollbar-thumb {\n  background: #374151;\n  border-radius: 5px;\n}\n\n.wizard-content::-webkit-scrollbar-thumb:hover {\n  background: #4b5563;\n}\n\n/* Configuración de dispositivos */\n.summary-device-actions {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.summary-device-configure {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  padding: 0;\n  background: #374151;\n  border: none;\n  border-radius: 8px;\n  color: #9ca3af;\n  cursor: pointer;\n  transition: all 0.2s;\n  flex-shrink: 0;\n}\n\n.summary-device-configure:hover {\n  background: #4B5563;\n  color: #60A5FA;\n  transform: scale(1.05);\n}\n\n.summary-device-configure.configured {\n  background: #374151;\n  color: #4ade80;\n}\n\n.summary-device-configure.configured:hover {\n  background: #4B5563;\n  color: #86efac;\n  transform: scale(1.05);\n}\n\n.summary-device-configured {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 4px 8px;\n  background: rgba(34, 197, 94, 0.15);\n  border: 1px solid rgba(34, 197, 94, 0.3);\n  border-radius: 6px;\n  color: #4ade80;\n  font-size: 11px;\n  font-weight: 600;\n  flex-shrink: 0;\n}\n\n.summary-device-item {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 10px 12px;\n  background: rgba(255, 255, 255, 0.02);\n  border: 1px solid rgba(255, 255, 255, 0.05);\n  border-radius: 6px;\n  transition: all 0.2s;\n}\n\n.summary-device-item:hover {\n  background: rgba(255, 255, 255, 0.04);\n  border-color: rgba(255, 255, 255, 0.1);\n}\n\n.summary-device-info {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 8px;\n  flex: 1;\n  min-width: 0;\n}\n\n.summary-device-info .summary-device-serial {\n  margin-right: 4px;\n}\n\n.summary-device-info .summary-device-model {\n  margin-right: 4px;\n}\n\n.summary-device-info .summary-device-configured {\n  margin-left: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
